enum SupportCaseStatus {
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Escalated = 'Escalated',
  Closed = 'Closed',
  ReOpened = 'ReOpened',
}

export default SupportCaseStatus;
